import React from "react";
import { InformationCircleIcon } from "@heroicons/react/outline";

const InfoTooltip = ({ text }) => {
  return (
    <div className="relative group flex items-center">
      <InformationCircleIcon
        className="h-5 w-5 text-primary-600 cursor-help"
        aria-hidden="true"
      />
      <span className="sr-only">{text}</span>
      <div
        className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-max max-w-xs p-2 bg-neutral-800 text-white text-xs rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 ease-in-out z-40 pointer-events-none"
        role="tooltip"
      >
        {text}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-solid border-4 border-transparent border-t-neutral-800"></div>
      </div>
    </div>
  );
};

export default InfoTooltip;